// Centralized login redirect helper to handle 401s and preserve return path
// Uses an in-memory flag plus localStorage to prevent redirect storms.

const REDIRECT_FLAG_KEY = 'ud_redirectingToLogin';
let isRedirecting = false;

function getCurrentPathWithQueryAndHash(): string {
  if (typeof window === 'undefined') return '/';
  const { pathname, search, hash } = window.location;
  return `${pathname || '/'}${search || ''}${hash || ''}`;
}

function isOnAuthPage(): boolean {
  if (typeof window === 'undefined') return false;
  const p = window.location.pathname || '';
  return p.startsWith('/portal/login') || p.startsWith('/portal/forgot-password');
}

export function startLoginRedirect(returnTo?: string): void {
  if (typeof window === 'undefined') return;
  if (isRedirecting || isLoginRedirectInProgress() || isOnAuthPage()) return;
  try {
    localStorage.setItem(REDIRECT_FLAG_KEY, 'true');
  } catch (_) { /* ignore storage errors */ }
  isRedirecting = true;

  const target = '/portal/login';
  // const target = '/portal/login';
  const rt = encodeURIComponent(returnTo || getCurrentPathWithQueryAndHash());
  const sep = target.includes('?') ? '&' : '?';
  const url = `${target}${rt ? `${sep}returnTo=${rt}` : ''}`;
  // Use assign to create a new history entry and leave current page as referrer
  window.location.assign(url);
}

export function isLoginRedirectInProgress(): boolean {
  if (isRedirecting) return true;
  try {
    return localStorage.getItem(REDIRECT_FLAG_KEY) === 'true';
  } catch (_) {
    return false;
  }
}

export function clearLoginRedirectFlag(): void {
  isRedirecting = false;
  try {
    localStorage.removeItem(REDIRECT_FLAG_KEY);
  } catch (_) { /* ignore */ }
}

export function buildReturnToFromLocation(): string {
  return getCurrentPathWithQueryAndHash();
}
